import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum ActivityLevel {
  Sedentary = "sedentary",
  SomewhatActive = "somewhatActive",
  VeryActive = "veryActive",
  HardlySitStill = "hardlySitStill",
}

const activityQuestion = {
  name: 'activity',
  title: loc("quiz.activity.title"),
  description: loc("quiz.activity.description"),
  type: "radiogroup",
  choices: [
    {
      value: ActivityLevel.Sedentary,
      text: locIconButton("quiz.activity.choices.sedentary", "🪑"),
    },
    {
      value: ActivityLevel.SomewhatActive,
      text: locIconButton("quiz.activity.choices.somewhatActive", "🚶‍♂"),
    },
    {
      value: ActivityLevel.VeryActive,
      text: locIconButton("quiz.activity.choices.veryActive", "🏃‍♂"),
    },
    {
      value: ActivityLevel.HardlySitStill,
      text: locIconButton("quiz.activity.choices.hardlySitStill", "🤸"),
    },
  ],
  isRequired: true,
};

export {
  ActivityLevel,
  activityQuestion,
}